export function exhaustiveCheck(type: never): never {
  throw new Error(`Missing type ${type}`)
}
